import { render, staticRenderFns } from "./AppSelectBox.vue?vue&type=template&id=646128a9&scoped=true&"
import script from "./AppSelectBox.vue?vue&type=script&lang=js&"
export * from "./AppSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./AppSelectBox.vue?vue&type=style&index=0&id=646128a9&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646128a9",
  null
  
)

export default component.exports